export class ModalProps {
  title: string;
  primaryBtnLabel: string;
  secondaryBtnLabel: string;
  secondaryBtnOnClickClose: boolean;
  size: string;
  show: boolean;
  showSecondaryBtn: boolean;
  visibleStep: string;
}

export class GoogleAuthReturn {
  Status: string;
  totpKey: string = "";
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/security/model.ts